import { FC } from 'react'

import { BLACK_COLOR } from '../../utils/constants'

const ChatIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={`chat-icon ${className}`}
    width="35"
    height="35"
    fill={BLACK_COLOR}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.465 24.346h.004l.002.004 2.66-1.33.886.324c1.292.472 2.679.718 4.108.718.803 0 1.593-.077 2.362-.23l.425 2.146c-.898.178-1.83.272-2.787.272a14.14 14.14 0 0 1-4.86-.852l-6.078 3.04 1.472-5.885C1.393 20.39 0 17.453 0 14.219 0 7.574 5.876 2.188 13.125 2.188c6.548 0 11.977 4.395 12.965 10.144l-2.156.37c-.813-4.73-5.364-8.327-10.809-8.327-6.081 0-10.938 4.452-10.938 9.844 0 2.537 1.072 4.929 2.982 6.751l.92.879-.624 2.497Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m27.466 30.14 5.346 2.672-1.222-4.89c2.1-1.793 3.41-4.33 3.41-7.14 0-5.437-4.897-9.845-10.938-9.845-6.04 0-10.937 4.408-10.937 9.844 0 5.437 4.897 9.844 10.938 9.844 1.188 0 2.332-.17 3.403-.486Zm2.703-3.88-1.03.88.398 1.589-1.863-.931-.826.243a9.856 9.856 0 0 1-2.785.396c-4.881 0-8.75-3.482-8.75-7.656 0-4.174 3.869-7.656 8.75-7.656 4.88 0 8.75 3.482 8.75 7.656 0 2.079-.955 4.036-2.644 5.478Z"
    />
  </svg>
)

export default ChatIcon
